import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ListModeradores from './ListModeradores';
import UserNew from './UserNew';
import UserEdit from './UserEdit';

export default class AdmUsuarios extends React.Component {
    render() {
        return (
            <div>
                <Routes>
                    <Route path="" element={<ListModeradores />} />
                    <Route path="NuevoUser" element={<UserNew />} />
                    <Route path="Editar/:id" element={<UserEdit />} />
                    <Route path="Editar/:id" element={<UserEdit />} />
                </Routes >
            </div >
        );
    }
}